<template>
  <div class="h-full" style="z-index: 0">
    <p class="font-18 font-weight-medium ml-5 pt-1 mb-0">Detalhes das categorias</p>

    <div
      :class="{'d-flex mt-n6': !VISAO_VERTICAL_ATIVA, 'pb-7': VISAO_VERTICAL_ATIVA}"
      class="h-full"
    >
      <div :class="CLASSES_CSS_GRAFICOS">
        <GraficoMovimentacoes class="pr-1" :class="{'pb-2': VISAO_VERTICAL_ATIVA}" />
      </div>

      <v-divider v-show="VISAO_VERTICAL_ATIVA" class="mx-2" :vertical="!VISAO_VERTICAL_ATIVA" />

      <div :class="CLASSES_CSS_GRAFICOS">
        <GraficoRuptura class="pl-1 pr-2" :class="{'pt-2': VISAO_VERTICAL_ATIVA}" />
      </div>
    </div>
  </div>
</template>

<script>
import GraficoMovimentacoes from './Movimentaoes/Index.vue';
import GraficoRuptura from './Ruptura/Index.vue';

export default {
  name: "Index",
  components: {
    GraficoMovimentacoes,
    GraficoRuptura
  },
  computed: {
    VISAO_VERTICAL_ATIVA() {
      return this.$store.getters['CompraProdutosGerais/getVisaoVertical'];
    },
    CLASSES_CSS_GRAFICOS() {
      return {
        'w-full h-50-porcento': this.VISAO_VERTICAL_ATIVA,
        'w-50-porcento': !this.VISAO_VERTICAL_ATIVA,
      };
    }
  }
}
</script>

<style scoped>
</style>
